import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Twitter, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Services: [
    'Creative Design',
    'Social Media Management',
    'Web Development',
    'SEO Optimization',
    'Performance Marketing',
    'E-commerce Solutions'],

    Company: [
    'About Us',
    'Our Team',
    'Careers',
    'Blog',
    'Case Studies',
    'Contact'],

    Resources: [
    'Help Center',
    'Privacy Policy',
    'Terms of Service',
    'FAQ',
    'Sitemap']

  };

  const socialLinks = [
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Instagram, href: '#', label: 'Instagram' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Twitter, href: '#', label: 'Twitter' }];


  return (
    <footer className="bg-slate-900 text-slate-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold text-white mb-4">BrandMitra</h3>
            <p className="text-slate-400 mb-6 leading-relaxed">
              Your trusted partner in digital transformation. We deliver performance-driven marketing solutions that drive real business growth.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3 mb-6">
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-orange-500 flex-shrink-0 mt-1" />
                <span className="text-sm">501, Vihan Commercial Complex, Goregaon, Mumbai - 400063</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-orange-500 flex-shrink-0" />
                <a href="mailto:support@brandmitra.in" className="text-sm hover:text-orange-500 transition-colors">
                  support@brandmitra.in
                </a>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const IconComponent = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    className="w-10 h-10 bg-slate-800 hover:bg-orange-600 rounded-lg flex items-center justify-center transition-colors duration-300">

                    <IconComponent className="w-5 h-5" />
                  </a>);

              })}
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([title, links]) =>
          <div key={title}>
              <h4 className="text-white font-bold mb-4">{title}</h4>
              <ul className="space-y-3">
                {links.map((link, index) =>
              <li key={index}>
                    {link === 'Privacy Policy' ?
                <Link
                  to="/privacy-policy"
                  data-testid="footer-privacy-policy-link"
                  className="text-slate-400 hover:text-orange-500 transition-colors text-sm">

                      {link}
                    </Link> :
                <a
                  href="#"
                  className="text-slate-400 hover:text-orange-500 transition-colors text-sm">

                      {link}
                    </a>
                }
                  </li>
              )}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">
              © {currentYear} BrandMitra Advertising. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" data-testid="footer-bottom-privacy-link" className="text-sm text-slate-400 hover:text-orange-500 transition-colors">
                Privacy Policy
              </Link>
              <a href="#" className="text-sm text-slate-400 hover:text-orange-500 transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-sm text-slate-400 hover:text-orange-500 transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;